'use client'
import { CONNECTED_WALLETS_INFO } from '../../../utils/constants/localStorage.js';
import '@dynamic-labs/sdk-api-core';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../../utils/constants/colors.js';
import '../../../utils/constants/values.js';
import { LocalStorage } from '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';

const clearExpiredData = (store) => {
    const { projectSettings, networkConfigurations, user } = store.getState();
    // TODO: we can clean this up once we move wallet info to the store
    const [connectedWalletData] = LocalStorage.getFromLS(CONNECTED_WALLETS_INFO) || [];
    const shouldRemoveSettingsAndConfigs = !user && !connectedWalletData;
    if ((projectSettings && projectSettings.expiresAt < Date.now()) ||
        shouldRemoveSettingsAndConfigs) {
        store.setState({ projectSettings: undefined });
    }
    if ((networkConfigurations && networkConfigurations.expiresAt < Date.now()) ||
        shouldRemoveSettingsAndConfigs) {
        store.setState({ networkConfigurations: undefined });
    }
    return store;
};

export { clearExpiredData };
